// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.el-menu-item[data-v-20da0478] {\n  font-size: 22px;\n  font-weight: 400;\n}\n.el-menu--horizontal > .el-menu-item.is-active[data-v-20da0478] {\n  border-bottom-color: #05AE09;\n  color: #05AE09;\n}\n.el-menu--horizontal > .el-menu-item[data-v-20da0478] {\n  color: #000;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
